import React from 'react';

type Props = {}

export default function LayoutAppLoading(props:Props) {

    const onTopOverlayClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div className="ui-view-loading view-loading" onClick={onTopOverlayClick}>
            <div className="gd-loading main-area">
                <img src={gdConfig.assetsPath+"/skin/common/loader/app-loading.gif?43"} />
                <p>Loading ...</p>
            </div>
        </div>
    );
}
